import { useEffect, useState } from "react";

function bandColor(score) {
  if (score >= 75) return "#8C3333";
  if (score >= 50) return "#A96143";
  if (score >= 25) return "#A68A56";
  return "#475F51";
}

/** Horizontal bar list of per-dimension scores. Bars expand from 0 on mount. */
export const DimensionBars = ({ dimensions, primaryKey, primaryLabel = "Primary" }) => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 200);
    return () => clearTimeout(t);
  }, []);

  const sorted = [...dimensions].sort((a, b) => b.score - a.score);

  return (
    <div className="flex flex-col gap-6" data-testid="dimension-bars">
      {sorted.map((d) => {
        const isPrimary = d.key === primaryKey;
        return (
          <div key={d.key} data-testid={`dimension-row-${d.key}`}>
            <div className="flex items-baseline justify-between mb-2">
              <span className={`text-sm ${isPrimary ? "text-[#0B0E14] font-semibold" : "text-[#4A5568]"}`}>
                {d.name}
                {isPrimary && (
                  <span className="ml-3 text-[10px] uppercase tracking-[0.18em] text-[#A68A56]">{primaryLabel}</span>
                )}
              </span>
              <span className="font-display text-base font-medium text-[#0B0E14] tabular-nums">{d.score}</span>
            </div>
            <div className="h-[10px] w-full bg-[#E2DFD8]">
              <div
                className="h-full"
                style={{
                  width: ready ? `${d.score}%` : "0%",
                  backgroundColor: bandColor(d.score),
                  transition: "width 1s cubic-bezier(0.22, 1, 0.36, 1)",
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
